export default __webpack_public_path__ + "static/media/lostAstronaut.8fbbc691.png";